import React, { Component } from 'react';
//import {Alert} from 'react-bootstrap';
import { Jumbotron, Form, Col, Table, Button, Alert, Row } from 'react-bootstrap';
//import {Toast} from 'react-bootstrap';
import Menu from '../../menu';
import ConfirmSend from '../../subcomponent/confirmEndPos';
import config from '../../../config';
import { IoIosRemoveCircle } from "react-icons/io";
import { IconContext } from "react-icons";
import Numeroaletras from '../../../middleware/numbertoletter';
import funciones from '../../../middleware/funciones';
import SearchItem from '../../subcomponent/searchItem';
import SearchClient from '../../subcomponent/searchClient';

export class post extends Component {
    constructor(props) {
        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        const currentUser = sessionStorage.getItem('vendedor');
        super(props);
        this.state = {
            data: [],
            empresa: currentCompany,
            tipo: currentUserType,
            showAlert: false,
            numeroDocumento: 0,
            clientes: [],
            prefijos: [],
            forma_pago: [],
            vendedor: [],
            retenciones: [],
            inventario: [],
            bodega: "",
            turno: [],
            currentUser,
            CEDULA: "",
            NOMBRE: "",
            DIRECCION: "",
            TELEFONO: "",
            TIPO: "2",
            PREFIJO: "",
            NUMERO_FACTURA: 0,
            CLIENTE: "",
            id_turno: "",
            tope: 100,
            RENTA: 0,
            RETEIVA: 0,
            RETEICA: 0,
            RETEOTROS: 0,
            VENDEDOR_SELECTED: "",
            OBSERVACION_FACTURA: "",
            SHOW_DETAIL: false,
            data_items: [],
            detalle_factura: [],
            data_cliente: [],
            metodos: [],
            isInv: 1,
            totales: {
                TOTAL_BRUTO: 0,
                RETENCION: 0,
                TOTAL_IVA: 0,
                SUBTOTAL: 0,
                TOTAL_DESCUENTOS: 0,
                TOTAL_PAGAR: 0
            },
            items_barcode: []
        };
    }

    componentDidMount() {
        this.initFactura();
    }

    initFactura = () => {
        const inputName = document.getElementById("Nombre");
        if (inputName) inputName.value = "";
        const { currentUser } = this.state;
        const datasend = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'currentUser': currentUser,
            }
        }
        fetch(config.servBackEnd + '/post/', datasend).then(response => response.json())
            .then(data => {
                const cData = data.data;
                const vendedor = cData[0][0];
                const data_items = cData[1];
                const retenciones = cData[2];
                const data_cliente = cData[3];
                const clientes = cData[4];
                const turno = cData[5];
                const metodos = cData[6];
                const inventario = cData[7];
                const items_barcode = cData[9];
                this.setState({
                    vendedor,
                    data_items,
                    retenciones,
                    clientes,
                    data_cliente,
                    turno,
                    metodos,
                    tope: vendedor.TOPE_DSCTO,
                    TIPO: "2",
                    bodega: vendedor.BODEGA,
                    isInv: vendedor.AFECTA_INVENTARIO,
                    inventario,
                    PREFIJO: vendedor.POST,
                    NUMERO_FACTURA: 0,
                    CLIENTE: "",
                    CEDULA: "",
                    NOMBRE: "",
                    DIRECCION: "",
                    TELEFONO: "",
                    SHOW_DETAIL: false,
                    items_barcode
                });
                this.clearItem();
            });
    }

    changeCantidad = ({ target }, position) => {
        const newDetalle = this.state.detalle_factura;
        let { value } = target;
        const { name } = target;
        if (name === "DESCUENTO" && value > 100) value = 100;
        newDetalle.forEach((element, index) => {
            if (position === index) {
                if (name === "CANTIDAD") element.CANTIDAD = value;
                if (name === "DESCUENTO") element.DESCUENTO = value;
                if (name === "VALOR_UNI") element.VALOR_UNI = value;
            };
        });
        this.setState({ detalle_factura: newDetalle });
        this.calcTotales();
    }

    calcTotales = () => {
        const newDetalle = this.state.detalle_factura;
        const { retenciones } = this.state;
        const { data_cliente } = this.state;
        let RENTA = 0;
        let RETEIVA = 0;
        let RETEICA = 0;
        let RETEOTROS = 0;
        let TOTAL_BRUTO = 0;
        let RETENCION = 0;
        let TOTAL_IVA = 0;
        let SUBTOTAL = 0;
        let TOTAL_DESCUENTOS = 0;
        let TOTAL_PAGAR = 0;
        newDetalle.forEach(element => {
            element.TOTAL = (element.CANTIDAD * element.VALOR_UNI);
            element.VALOR_DCTO = funciones.round((element.TOTAL * element.DESCUENTO / 100), 2);
            element.VALOR_IVA = ((element.TOTAL - element.VALOR_DCTO) * element.PORCENTAJE_IVA / 100);
            element.RENTA_DETALLE = ((element.TOTAL - element.VALOR_DCTO) * element.PORCENTAJE_RETENCION / 100);

            RENTA += (element.RENTA_DETALLE) ? element.RENTA_DETALLE : 0;
            RETENCION += (element.RENTA_DETALLE) ? element.RENTA_DETALLE : 0;
            TOTAL_BRUTO += element.TOTAL;
            TOTAL_IVA += element.VALOR_IVA;
            TOTAL_DESCUENTOS += element.VALOR_DCTO;
            SUBTOTAL = TOTAL_BRUTO - TOTAL_DESCUENTOS;
            TOTAL_PAGAR = TOTAL_BRUTO - TOTAL_DESCUENTOS + TOTAL_IVA;
        });
        newDetalle.forEach(element => {
            if (element.BASE_MINIMA_VENTA > SUBTOTAL) {
                RENTA -= (element.RENTA_DETALLE) ? element.RENTA_DETALLE : 0;
                RETENCION -= (element.RENTA_DETALLE) ? element.RENTA_DETALLE : 0;
                element.RENTA_DETALLE = 0;
            }
        });
        if (data_cliente[0].LIQUIDA_RETEIVA) {
            retenciones.forEach(element => {
                if (element.TIPO_RETENCION === "2") {
                    RETEIVA += (element.BASE_MINIMA_VENTA <= SUBTOTAL) ? (TOTAL_IVA * element.PORCENTAJE_RETENCION / 100) : 0;
                    RETENCION += RETEIVA;
                }
            });
        }

        if (data_cliente[0].LIQUIDA_RETEICA) {
            retenciones.forEach(element => {
                if (element.TIPO_RETENCION === "3") {
                    RETEICA += (element.BASE_MINIMA_VENTA <= SUBTOTAL) ? (SUBTOTAL * element.PORCENTAJE_RETENCION / 100) : 0;
                    RETENCION += RETEICA;
                }
            });
        }

        if (data_cliente[0].LIQUIDA_RETEOTROS) {
            retenciones.forEach(element => {
                if (element.TIPO_RETENCION === "4") {
                    RETEOTROS += (element.BASE_MINIMA_VENTA <= SUBTOTAL) ? (SUBTOTAL * element.PORCENTAJE_RETENCION / 100) : 0;
                    RETENCION += RETEOTROS;
                }
            });
        }

        TOTAL_PAGAR -= RETENCION;

        const newTotal = {
            TOTAL_BRUTO,
            RETENCION,
            TOTAL_IVA,
            SUBTOTAL,
            TOTAL_DESCUENTOS,
            TOTAL_PAGAR
        }

        this.setState({
            RENTA,
            RETEIVA,
            RETEICA,
            RETEOTROS,
            detalle_factura: newDetalle,
            totales: newTotal
        })
    }

    removeitem = (index) => {
        let newData = this.state.detalle_factura;
        newData.splice(index, 1);
        this.setState({ detalle_factura: newData });
        this.calcTotales();
    }

    clearItem = () => {
        this.setState({
            detalle_factura: [],
            totales: {
                TOTAL_BRUTO: 0,
                RETENCION: 0,
                TOTAL_IVA: 0,
                SUBTOTAL: 0,
                TOTAL_DESCUENTOS: 0,
                TOTAL_PAGAR: 0
            },
            RENTA: 0,
            RETEIVA: 0,
            RETEICA: 0,
            RETEOTROS: 0
        })

    }

    saveInvoice = (pagos) => {
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
        const yyyy = today.getFullYear();
        const todayFormat = yyyy + "-" + mm + "-" + dd;
        const { clientes } = this.state;
        const { turno } = this.state;
        const id_turno = turno[0].ID_TURNOS;
        let item_detalle = [];
        let cliente = [];
        if (this.state.TIPO === "2") cliente = this.state.data_cliente[0];
        if (this.state.TIPO === "1") {
            cliente = {
                DOCUMENTO_CLIENTE: this.state.CEDULA,
                DV_CLIENTE: "0",
                TIPO_IDENTIFICACION: 13,
                NOMBRE_CLIENTE: this.state.NOMBRE,
                DIRECCION_CLIENTE: this.state.DIRECCION,
                NOMBRE_DEPARTAMENTO_CLIENTE: "",
                CODIGO_POSTAL: "",
                NOMBRE_CIUDAD_CLIENTE: "",
                CODIGO_DEPARTAMENTO_CLIENTE: "",
                CODIGO_CIUDAD_CLIENTE: "",
                TELEFONO_FIJO_CLIENTE: this.state.TELEFONO,
                EMAIL_CLIENTE: "",
                BARRIO_CLIENTE: ""
            };
        }
        if (this.state.TIPO === "3") {
            clientes.forEach(element => {
                if (element.ID_CLIENTES.toString() === this.state.CLIENTE.toString()) cliente = element;
            });

        };
        const { totales } = this.state;
        const { vendedor } = this.state;
        //const { retenciones } = this.state;
        const { detalle_factura } = this.state;
        const valorTexto = Numeroaletras(totales.TOTAL_PAGAR);

        let currentVend = vendedor;

        const subtotal_send = totales.SUBTOTAL + totales.TOTAL_DESCUENTOS + totales.TOTAL_IVA;
        const Cabecera = {
            ID_EMPRESA: this.state.empresa,
            CODIGO_EMPRESA: '01',
            CENTRO_OPERACION: '01',
            NUMERO_FACTURA_CABECERA: this.state.NUMERO_FACTURA,
            TIPO_DOCUMENTO_CABECERA: this.state.PREFIJO,
            NUMERO_REMISION: "",
            NUMERO_PEDIDO: "",
            DOCUMENTO_ALTERNO: "",
            ID_TRANSACCION: "",
            DOCUMENTO_CLIENTE: cliente.DOCUMENTO_CLIENTE,
            DIGITO_VERIFICACION_CLIENTE: cliente.DV_CLIENTE,
            TIPO_IDENTIFICACION_CLIENTE: cliente.TIPO_IDENTIFICACION,
            NOMBRE_CLIENTE: cliente.NOMBRE_CLIENTE,
            DIRECCION_CLIENTE: cliente.DIRECCION_CLIENTE,
            DEPARTAMENTO_CLIENTE: cliente.NOMBRE_DEPARTAMENTO_CLIENTE,
            CODIGO_POSTAL: cliente.CODIGO_POSTAL,
            CIUDAD_CLIENTE: cliente.NOMBRE_CIUDAD_CLIENTE,
            CODIGO_DEPARTAMENTO_CLIENTE: cliente.CODIGO_DEPARTAMENTO_CLIENTE,
            CODIGO_CIUDAD_CLIENTE: cliente.CODIGO_CIUDAD_CLIENTE,
            TELEFONO_CLIENTE: cliente.TELEFONO_FIJO_CLIENTE,
            EMAIL_CLIENTE: cliente.EMAIL_CLIENTE,
            VENDEDOR: currentVend.NOMBRE_VENDEDOR,
            FECHA_DOCUMENTO: todayFormat,
            FECHA_VENCIMIENTO_DOCUMENTO: todayFormat,
            FECHA_DOCUMENTO_ALTERNO: "",
            PORCENTAJE_IVA: 0,
            PORCENTAJE_IMPOCONSUMO: 0,
            TOTAL_BRUTO: totales.TOTAL_BRUTO,
            TOTAL_DESCUENTO_LINEA: totales.TOTAL_DESCUENTOS,
            TOTAL_DESCUENTO_GLOBAL: 0,
            TOTAL_IVA: totales.TOTAL_IVA,
            TOTAL_IMPOCONSUMO: 0,
            TOTAL_RETENCION: totales.RETENCION,
            RET_IVA: this.state.RETEIVA,
            RET_ICA: this.state.RETEICA,
            RET_FUENTE: this.state.RENTA,
            RET_OTROS: this.state.RETEOTROS,
            SUBTOTAL: subtotal_send,
            TOTAL_VENTA: totales.TOTAL_PAGAR,
            CONDICION_PAGO: "CONTADO",
            VALOR_LETRAS: valorTexto,
            TASA_MONEDA: "1",
            TIPO_MONEDA: "COP",
            OBSERVACION1: this.state.OBSERVACION_FACTURA,
            OBSERVACION2: "",
            CUFE: "",
            DOCUMENTO_ENVIADO: 0,
            DOCUMENTO_ENVIADO_OBSERVACION: "",
            PDF: "",
            PREFIJO_DIAN: this.state.PREFIJO,
            FACTURA_ASOCIADA: "",
            BARRIO: cliente.BARRIO_CLIENTE,
            CODIGO_VENDEDOR: currentVend.CODIGO_VENDEDORES
        }

        let Detalle = []

        detalle_factura.forEach((element, index) => {
            if (element.DESCRIPCION_ITEM !== "") {
                Detalle.push(
                    {
                        ID_EMPRESA: this.state.empresa,
                        CODIGO_EMPRESA: '01',
                        CENTRO_OPERACION: '01',
                        NUMERO_FACTURA_DETALLE: this.state.NUMERO_FACTURA,
                        TIPO_DOCUMENTO_DETALLE: this.state.PREFIJO,
                        INDICE_ITEM: index + 1,
                        ITEM_ID: element.ID_ITEMS,
                        ITEM_DESCRIPCION: element.DESCRIPCION_ITEM,
                        SERIAL: "",
                        UNIDAD_MEDIDA: "UND",
                        CANTIDAD_1: element.CANTIDAD,
                        CANTIDAD_2: 0,
                        PRECIO_UNITARIO_DETALLE: element.VALOR_UNI,
                        TOTAL_BRUTO_DETALLE: element.TOTAL,
                        DESCUENTO_LINEA_DETALLE: element.VALOR_DCTO,
                        IVA_DETALLE: element.VALOR_IVA,
                        IMPOCONSUMO_DETALLE: 0,
                        PORCENTAJE_IVA_DETALLE: element.PORCENTAJE_IVA,
                        PORCENTAJE_IMPOCONSUMO_DETALLE: 0,
                        PORCENTAJE_DESCUENTO_DETALLE: element.DESCUENTO
                    }
                );
                item_detalle.push({
                    motivo: "S",
                    ID_ITEMS: element.ID_ITEMS,
                    cantidad: element.CANTIDAD,
                    costo: 0,
                    observacion: ""
                });
            }
        });

        const factura = {
            Idturno: id_turno,
            Tipo: this.state.TIPO,
            Cabecera,
            Detalle,
            pagos
        }

        const datasend = {
            method: 'POST',
            body: JSON.stringify(factura),
            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': this.state.tipo,
            }
        };

        fetch(config.servBackEnd + '/post/create', datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    const datasend = {
                        method: 'POST',
                        body: JSON.stringify({
                            empresa: this.state.empresa,
                            bodega: this.state.bodega,
                            tipoMov: this.state.PREFIJO,
                            observacion: this.state.OBSERVACION_FACTURA,
                            numeroDoc: data.DOCUMENTO_CREADO,
                            items: item_detalle
                        }),
                        headers: {
                            'Content-Type': 'application/json',
                            'tipo': this.state.tipo,
                        }
                    }
                    if (this.state.isInv === 1) {
                        fetch(config.servBackEnd + '/inventary/create', datasend).then(response => response.json())
                            .then(data => { console.log(data) });
                    }
                    this.setState({ showAlert: true, numeroDocumento: data.DOCUMENTO_CREADO });
                    const newid = data.data.insertId;
                    this.impresionPDF(newid);
                    this.initFactura();
                } 
            });
    }

    createRetenciones = () => {
        let cont = 0;
        let children = [];
        const { retenciones } = this.state;
        while (cont < 4) {
            if (retenciones[cont]) {
                switch (retenciones[cont].TIPO_RETENCION) {
                    case "1":
                        children.push(<td key={'tr'} >{retenciones[cont].DESCRIPCION_RETENCION + ": " + this.state.RENTA}</td>);
                        break;
                    case "2":
                        children.push(<td key={'ti'} >{retenciones[cont].DESCRIPCION_RETENCION + ": " + this.state.RETEIVA}</td>);
                        break;
                    case "3":
                        children.push(<td key={'tc'} >{retenciones[cont].DESCRIPCION_RETENCION + ": " + this.state.RETEICA}</td>);
                        break;
                    case "4":
                        children.push(<td key={'to'} >{retenciones[cont].DESCRIPCION_RETENCION + ": " + this.state.RETEOTROS}</td>);
                        break;
                    default:
                        children.push(<td key={'t' + cont} ></td>);
                };
            }
            else {
                children.push(<td key={'t' + cont} ></td>);
            }
            cont += 1;
        }
        return children;
    }

    changeTypePost = ({ target }) => {
        const { value } = target;
        const { clientes } = this.state;
        const { vendedor } = this.state;
        if (value === "1") {
            this.setState({
                CEDULA: "",
                NOMBRE: "",
                DIRECCION: "",
                TELEFONO: "",
                CLIENTE: "",
                TIPO: value,
                PREFIJO: vendedor.POST
            })
        }
        if (value === "2") {
            this.setState({
                CEDULA: clientes.DOCUMENTO_CLIENTE,
                NOMBRE: clientes.NOMBRE_CLIENTE,
                DIRECCION: clientes.DIRECCION_CLIENTE,
                TELEFONO: clientes.TELEFONO_FIJO_CLIENTE,
                CLIENTE: "",
                TIPO: value,
                PREFIJO: vendedor.POST
            })
        }
        if (value === "3") {
            this.setState({
                CEDULA: "",
                NOMBRE: "",
                DIRECCION: "",
                TELEFONO: "",
                CLIENTE: "",
                TIPO: value,
                PREFIJO: vendedor.POSTFE
            })
        }

    }

    impresionPDF = (id) => {
        const datasend = {
            method: 'GET',
            headers: {
                'Content-Type': 'blob',
                'empresa': this.state.empresa
            }
        }
        fetch(config.servBackEnd + '/post/getpdf/' + id, datasend)
            .then((res) => {
                if (res.ok) return res.blob();
            }).then(function (myBlob) {
                var objectURL = URL.createObjectURL(myBlob);
                document.querySelector('#pdf-frame').src = '';
                document.querySelector('#pdf-frame').src = objectURL;
                objectURL = URL.revokeObjectURL(myBlob);
            }).then(
                function () {
                    window.setTimeout(function () {
                        document.querySelector('#pdf-frame').contentWindow.print();
                    }, 1000)
                })
            .catch((err) => {
                console.error(err);
            })
    }

    addItem = (data) => {
        const newdetalle = this.state.detalle_factura;
        const { bodega } = this.state;
        const precio = funciones.round((data.INC_IVA) ? (data.PRECIO / (1 + (data.IVA_ITEM / 100))) : data.PRECIO, 2);
        newdetalle.push({
            ID_ITEMS: data.ID_ITEMS,
            DESCRIPCION_ITEM: data.DESCRIPCION_ITEM,
            CANTIDAD: 1,
            DESCUENTO: 0,
            VALOR_UNI: precio,
            VALOR_DCTO: 0,
            VALOR_IVA: 0,
            PORCENTAJE_IVA: data.IVA_ITEM,
            TOTAL: precio,
            disponible: 0
        });
        this.setState({ detalle_factura: newdetalle });
        this.calcTotales();
        this.updateCantidadDisponible(bodega);
    }

    addItemBarCode = (data) => {
        const newdetalle = this.state.detalle_factura;
        const { bodega } = this.state;
        const precio = funciones.round((data.INC_IVA) ? (data.PRECIO / (1 + (data.IVA_ITEM / 100))) : data.PRECIO, 2);
        newdetalle.push({
            ID_ITEMS: data.ID_ITEMS,
            DESCRIPCION_ITEM: data.DESCRIPCION_ITEM,
            CANTIDAD: data.CANTIDAD_BARCODE,
            DESCUENTO: 0,
            VALOR_UNI: precio,
            VALOR_DCTO: 0,
            VALOR_IVA: 0,
            PORCENTAJE_IVA: data.IVA_ITEM,
            TOTAL: precio,
            disponible: 0
        });
        this.setState({ detalle_factura: newdetalle });
        this.calcTotales();
        this.updateCantidadDisponible(bodega);
    }

    updateCantidadDisponible = (bod) => {
        const new_list_items = this.state.detalle_factura;
        const bodega_origen = bod;

        new_list_items.forEach(element => {
            element.disponible = this.findQuantity(element.ID_ITEMS, bodega_origen);
        });

        this.setState({
            detalle_factura: new_list_items
        });
    }

    findQuantity = (item, bodega) => {
        const { inventario } = this.state;
        for (let index = 0; index < inventario.length; index++) {
            const element = inventario[index];
            if (element.ID_BODEGA.toString() === bodega.toString() && element.ID_ITEMS.toString() === item.toString()) {
                return (element.CANTIDAD || 0);
            }
        }
        return 0;
    }

    selectCLient = (client) => {
        this.setState({ CLIENTE: client.ID_CLIENTES })
    }
    render() {
        const { vendedor } = this.state;
        const { detalle_factura } = this.state;
        const { data_items } = this.state;
        const { totales } = this.state;
        const { clientes } = this.state;
        const { numeroDocumento } = this.state;
        const { showAlert } = this.state;
        const { metodos } = this.state;
        const { tope } = this.state;
        const { items_barcode } = this.state;
        const changeCantidad = this.changeCantidad;
        const removeitem = this.removeitem;
        const clearItem = this.clearItem;
        const saveInvoice = this.saveInvoice;
        const changeTypePost = this.changeTypePost;
        const isPost = (vendedor.POST && vendedor.POST !== '') ? true : false;
        const isPostfe = (vendedor.POSTFE && vendedor.POSTFE !== '') ? true : false;
        const isBodega = (vendedor.BODEGA && vendedor.BODEGA !== 0) ? true : false;
        const showInv = (this.state.isInv === 1) ? true : false;

        return (

            <div className="contenedor">
                <iframe id="pdf-frame"></iframe>
                <Menu></Menu>
                <Jumbotron className="Jumbotron">
                    <h1>Modulo Facturas</h1>
                </Jumbotron>
                {showAlert &&
                    <Alert variant='success'>
                        El documento No {numeroDocumento}  se creo satisfactoriamente.
                </Alert>
                }

                {(this.state.turno.length > 0 && isPost && isPostfe && isBodega) &&

                    <Form>
                        <Form.Row>
                            <Form.Group as={Col} controlId="">
                                <Form.Label>TIPO FACTURA POST</Form.Label>
                                <Form.Control as="select" onChange={changeTypePost} value={this.state.TIPO} required>
                                    <option value="1">Directa</option>
                                    <option value="2">Rapida</option>
                                    <option value="3">Facturacion Electronica</option>
                                </Form.Control>
                            </Form.Group>
                            <Form.Group as={Col} controlId="">
                                <Form.Label>CAJERO</Form.Label>
                                <Form.Control type="text" value={(vendedor.NOMBRE_VENDEDOR) ? vendedor.NOMBRE_VENDEDOR : ""} readOnly></Form.Control>
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col} controlId="">
                                <Form.Label>OBSERVACIONES</Form.Label>
                                <Form.Control type="text" onChange={(e) => this.setState({ OBSERVACION_FACTURA: e.target.value.toUpperCase() })} value={this.state.OBSERVACION_FACTURA} />
                            </Form.Group>
                        </Form.Row>
                        {this.state.TIPO === "1" &&
                            <Form.Row>
                                <Form.Group as={Col} controlId="">
                                    <Form.Label>CEDULA</Form.Label>
                                    <Form.Control type="text" value={this.state.CEDULA} onChange={(e) => this.setState({ CEDULA: e.target.value })} ></Form.Control>
                                </Form.Group>
                                <Form.Group as={Col} controlId="">
                                    <Form.Label>NOMBRE</Form.Label>
                                    <Form.Control type="text" value={this.state.NOMBRE} onChange={(e) => this.setState({ NOMBRE: e.target.value })} ></Form.Control>
                                </Form.Group>
                                <Form.Group as={Col} controlId="">
                                    <Form.Label>DIRECCION</Form.Label>
                                    <Form.Control type="text" value={this.state.DIRECCION} onChange={(e) => this.setState({ DIRECCION: e.target.value })} ></Form.Control>
                                </Form.Group>
                                <Form.Group as={Col} controlId="">
                                    <Form.Label>TELEFONO</Form.Label>
                                    <Form.Control type="text" value={this.state.TELEFONO} onChange={(e) => this.setState({ TELEFONO: e.target.value })} ></Form.Control>
                                </Form.Group>
                            </Form.Row>
                        }
                        {this.state.TIPO === "3" &&
                            <Form.Row>
                                <Form.Group as={Col}>
                                    <Form.Label>CLIENTE</Form.Label>
                                    <SearchClient data={clientes} event={this.selectCLient} ></SearchClient>
                                </Form.Group>
                            </Form.Row>
                        }
                        <div>
                            <ConfirmSend functionClose={saveInvoice} data={totales} metodos={metodos}></ConfirmSend>
                            <Button onClick={clearItem} className="m-3" disabled={detalle_factura.length === 0} >Limpiar</Button>
                            {/* <Button onClick={() => this.impresionPDF("17")} className="m-3"  >PDF</Button> */}
                        </div>

                        {this.state.TIPO !== "" &&
                            <div>
                                <Row>
                                    <Col sm={3}>
                                        <SearchItem data={data_items} event={this.addItem} data_barcode={items_barcode} event_barcode={this.addItemBarCode}></SearchItem>
                                    </Col>
                                    <Col>
                                        <Table striped bordered hover size="sm" responsive>
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th colSpan={(showInv === true) ? 2 : 3}>DESCRIPCION</th>
                                                    {showInv && <th>DISPONIBLE</th>}
                                                    <th>CANT.</th>
                                                    <th>% DSCTO</th>
                                                    <th>VR UNIT.</th>
                                                    <th>VR DSCTO</th>
                                                    <th>VR IVA</th>
                                                    <th>BRUTO</th>
                                                    <th>TOTAL</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {detalle_factura.map(function (element, index) {
                                                    return <tr key={'tr' + index}>
                                                        <td>
                                                            <IconContext.Provider value={{ size: "2em" }}>
                                                                <IoIosRemoveCircle onClick={() => removeitem(index)} />
                                                            </IconContext.Provider>
                                                        </td>
                                                        <td colSpan={(showInv === true) ? 2 : 3}>{element.DESCRIPCION_ITEM}</td>
                                                        {showInv && <td> {element.disponible} </td>}
                                                        <td> <Form.Control className="mediuminput" step="0.01" name="CANTIDAD" min="0.01" max={(showInv) ? element.disponible : 99999999999} type="number" onChange={(e) => changeCantidad(e, index)} disabled={element.ID_ITEMS === ""} value={element.CANTIDAD} /></td>
                                                        <td> <Form.Control className="shortinput" name="DESCUENTO" min="0" max={tope} type="number" onChange={(e) => changeCantidad(e, index)} disabled={element.ID_ITEMS === ""} value={Math.round(element.DESCUENTO)} /></td>
                                                        <td> <Form.Control className="mediuminput" name="VALOR_UNI" min="0" type="number" onChange={(e) => changeCantidad(e, index)} disabled={true} value={Math.round(element.VALOR_UNI)} /></td>
                                                        <td>{Math.round(element.VALOR_DCTO)}</td>
                                                        <td>{Math.round(element.VALOR_IVA)}</td>
                                                        <td>{Math.round(element.TOTAL)}</td>
                                                        <td>{Math.round(parseFloat(element.TOTAL) + parseFloat(element.VALOR_IVA))}</td>
                                                    </tr>
                                                })}
                                            </tbody>
                                        </Table>
                                        <Table striped bordered hover size="sm" responsive>
                                            <tbody>
                                                <tr>
                                                    <td></td>
                                                    <td><b>TOTAL BRUTO</b></td>
                                                    <td>{Math.round(totales.TOTAL_BRUTO)}</td>
                                                    <td><b>TOTAL DESCUENTOS</b></td>
                                                    <td>{Math.ceil(totales.TOTAL_DESCUENTOS)}</td>
                                                    <td><b>SUBTOTAL</b></td>
                                                    <td>{Math.round(totales.SUBTOTAL)}</td>
                                                    <td><b>RETENCION</b></td>
                                                    <td>{Math.round(totales.RETENCION)}</td>
                                                    <td><b>TOTAL IVA</b></td>
                                                    <td>{Math.round(totales.TOTAL_IVA)}</td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td><b>RENTA</b></td>
                                                    <td>{Math.round(this.state.RENTA)}</td>
                                                    <td><b>RETEIVA</b></td>
                                                    <td>{Math.round(this.state.RETEIVA)}</td>
                                                    <td><b>RETEICA</b></td>
                                                    <td>{Math.round(this.state.RETEICA)}</td>
                                                    <td><b>RETEOTROS</b></td>
                                                    <td>{Math.round(this.state.RETEOTROS)}</td>
                                                    <td><b>TOTAL</b></td>
                                                    <td>{Math.round(totales.TOTAL_PAGAR)}</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>
                            </div>
                        }
                    </Form>
                }
                {
                    this.state.turno.length === 0 &&
                    <div>
                        <h1>No tiene turno abierto</h1>
                        <h3>Solicite apertura al administrador</h3>
                    </div>
                }
                {(!isPost || !isPostfe || !isBodega) &&
                    <div>
                        <h1>Vendedor mal configurado</h1>
                        <h3>Por favor revisar la configuracion del vendedor {vendedor.NOMBRE}</h3>
                    </div>
                }
            </div>
        );
    }
}

export default post
